/**
 *
 * @returns {'eligibility' | 'qualify' | 'qualify-oneclick' | 'savings-estimates' | 'one-click' | 'sub-one' | 'unknown' | 'savings-estimates-static'}
 */
export function getFunnelFromUrl() {
  const url = window.location.href
  if (/eligibility/.test(url)) {
    return 'eligibility'
  }

  if (/qualify\/one-click/.test(url)) {
    return 'qualify-oneclick'
  }

  if (/qualify/.test(url)) {
    return 'qualify'
  }

  if (/\/savings-estimates\/submit/i.test(url)) {
    return 'savings-estimates-static'
  }

  if (/\/savings-estimates/i.test(url)) {
    return 'savings-estimates'
  }

  if (/\/one-click/i.test(url)) {
    return 'one-click'
  }

  if (/\/sub-one/i.test(url)) {
    return 'sub-one'
  }

  return 'unknown'
}
